// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__vaaH0","tableRow":"Table_tableRow__FpBjc","label":"Table_label__3-hd7","value":"Table_value__2HWzu"};